import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    background: ['shop now - image'],
    left_button: ['never show - button'],
    right_button: ['close - button']
  }
};

const BasicFullImageTracking: FC = () => {
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
.root_tracking {
    width: 100%;
    height: 100%;
    position: relative;

    .modal_wrapper {
      height: calc(100% - 72px);
    }

    .bottom_btn {
      width: 100%;
      height: 5rem;

      position: absolute;
      bottom: 0;
    }
    .bottom_btn_inner {
        height: 2.5rem;
    }

    .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
    }
}
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="modal_wrapper tracking_center">
          <EditTracking value={tracking?.background?.[0]} type="background" />
        </div>
        <div className="bottom_btn">
          <div className="bottom_btn_inner tracking_center">
            <EditTracking
              value={tracking?.left_button?.[0]}
              type="left_button"
            />
          </div>
          <div className="bottom_btn_inner tracking_center">
            <EditTracking
              value={tracking?.right_button?.[0]}
              type="right_button"
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default BasicFullImageTracking;
